module.exports = __webpack_public_path__ + "static/img/Educacion ambiental.727d8f39.png";